'use client';
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import React, { useEffect, useRef, useCallback } from 'react';
import { useTweetStore } from '../../hooks/useTweetStore';
import TweetComposerLayout from './TweetComposerLayout';
import { TWEET_COMPOSER_TEST_IDS } from '@edusense/shared-constants';
export default function UnifiedTweetComposer(param) {
    var _param_mode = param.mode, mode = _param_mode === void 0 ? 'tweet' : _param_mode, _param_referenceTweet = param.referenceTweet, referenceTweet = _param_referenceTweet === void 0 ? null : _param_referenceTweet, onSubmitAction = param.onSubmitAction, placeholder = param.placeholder, _param_autoFocus = param.autoFocus, autoFocus = _param_autoFocus === void 0 ? false : _param_autoFocus, _param_isOpen = param.isOpen, isOpen = _param_isOpen === void 0 ? true : _param_isOpen, externalImages = param.images, setImagesAction = param.setImagesAction, externalUser = param.user, _param_initialText = param.initialText, initialText = _param_initialText === void 0 ? '' : _param_initialText;
    var store = useTweetStore(undefined);
    var setText = store.setText, setMedia = store.setMedia, resetState = store.resetState, setFileInputRef = store.setFileInputRef, handleMediaUpload = store.handleMediaUpload, createSubmitData = store.createSubmitData;
    var fileInputRef = useRef(null);
    useEffect(function() {
        setFileInputRef(fileInputRef);
    }, [
        setFileInputRef
    ]);
    var previousIsOpenRef = useRef();
    var previousInitialTextRef = useRef();
    var previousExternalImagesRef = useRef();
    useEffect(function() {
        var wasOpen = previousIsOpenRef.current;
        if (!isOpen) {
            if (wasOpen) {
                resetState();
                previousInitialTextRef.current = undefined;
                previousExternalImagesRef.current = undefined;
            }
            previousIsOpenRef.current = false;
            return;
        }
        if (wasOpen !== true) {
            resetState();
        }
        if (typeof initialText === 'string' && initialText !== previousInitialTextRef.current) {
            setText(initialText);
            previousInitialTextRef.current = initialText;
        }
        if (Array.isArray(externalImages)) {
            if (externalImages !== previousExternalImagesRef.current) {
                setMedia(externalImages);
                previousExternalImagesRef.current = externalImages;
            }
        } else if (previousExternalImagesRef.current) {
            setMedia([]);
            previousExternalImagesRef.current = undefined;
        }
        previousIsOpenRef.current = true;
    }, [
        isOpen,
        initialText,
        externalImages,
        resetState,
        setText,
        setMedia
    ]);
    // 레퍼런스와 동일하게: 스토어 기반 데이터 생성 후 부모 onSubmitAction 호출
    var handleSubmit = useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(overrideContent) {
            var submitData, content, images, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        submitData = createSubmitData();
                        content = (overrideContent !== null && overrideContent !== void 0 ? overrideContent : submitData.content) || '';
                        // images는 문자열 배열로 변환 (스토어의 media url 기준)
                        images = (submitData.media || []).filter(function(m) {
                            return (m === null || m === void 0 ? void 0 : m.type) === 'image';
                        }).map(function(m) {
                            return m === null || m === void 0 ? void 0 : m.url;
                        }).filter(Boolean);
                        return [
                            4,
                            onSubmitAction({
                                content: content,
                                images: images,
                                poll: submitData.poll
                            })
                        ];
                    case 1:
                        _state.sent();
                        resetState();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        // 오류 시 상태 유지 (재시도 가능)
                        console.error('[UnifiedTweetComposer] submit error', error);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(overrideContent) {
            return _ref.apply(this, arguments);
        };
    }(), [
        createSubmitData,
        onSubmitAction,
        resetState
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("input", {
        type: "file",
        multiple: true,
        accept: "image/*,video/*",
        "data-composer-file-input": "true",
        style: {
            display: 'none'
        },
        ref: fileInputRef,
        onChange: handleMediaUpload,
        "data-testid": TWEET_COMPOSER_TEST_IDS.FILE_INPUT
    }), /*#__PURE__*/ React.createElement(TweetComposerLayout, {
        mode: mode,
        referenceTweet: referenceTweet,
        user: externalUser,
        placeholder: placeholder,
        autoFocus: autoFocus,
        isOpen: isOpen,
        onSubmitAction: handleSubmit,
        store: store,
        externalSetImages: setImagesAction
    }));
}
